import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { AppThunk } from 'store/types';
import { IParamsReq } from 'types';
import { ReportingOvpData } from 'features/Analytics/AnalyticsReportingOvp/types';

import { downloadFileByGet } from 'helpers';

interface AnalyticsReportingOvpStore {
  loading: boolean;
  downloadLoading: boolean;
  data: ReportingOvpData | null;
}

const initialState: AnalyticsReportingOvpStore = {
  loading: false,
  downloadLoading: false,
  data: null,
};

const reset: CaseReducer<AnalyticsReportingOvpStore> = () => initialState;

const loading: CaseReducer<AnalyticsReportingOvpStore, PayloadAction<boolean>> = (
  state,
  action,
) => {
  state.loading = action.payload;
};

const downloadLoading: CaseReducer<AnalyticsReportingOvpStore, PayloadAction<boolean>> = (
  state,
  action,
) => {
  state.downloadLoading = action.payload;
};

const data: CaseReducer<AnalyticsReportingOvpStore, PayloadAction<ReportingOvpData>> = (
  state,
  action,
) => {
  state.data = action.payload;
};

export const analyticsReportingOvpSlice = createSlice({
  name: 'analyticsReportingOvp',
  initialState,
  reducers: {
    reset,
    downloadLoading,
    loading,
    data,
  },
});

export const {
  reset: setReset,
  loading: setLoading,
  data: setData,
  downloadLoading: setDownloadLoading,
} = analyticsReportingOvpSlice.actions;

export const getAnalyticsReportingOvp =
  (params: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<ReportingOvpData>('/api/analytics/employees/', params)
      .then(({ data }) => {
        dispatch(setData(data));
      })
      .then(() => dispatch(setLoading(false)));
  };

export const getDownloadExcel =
  (project: number, params: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setDownloadLoading(true));

    downloadFileByGet({
      url: '/api/analytics/employees-excel/',
      params: { project, ...params },
    }).finally(() => dispatch(setDownloadLoading(false)));
  };
